module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAOBAMAAAC88gOBAAAAAXNSR0IArs4c6QAAABVQTFRF+PjISDhQcFiYgHhwqJDw+Pj4////KN7I+QAAAAF0Uk5TAEDm2GYAAABqSURBVBhXXc7BDUJBCARQTCxA7UCQBobM3fzYwYT+WzHfzR5wbvMCBLt+Rt52+MjLZnc391RCKW+0fiASElliLYgTkqjEgmZLWY0N57QSpQ25VnwDRYiq3jeiAhXlhVjw99hj9qdd7iO3LwhlJ60BhimOAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/images/types/Ghost.png
// module id = 165
// module chunks = 0